var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContactCenter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 45c0-6.627 5.373-12 12-12h10c6.627 0 12 5.373 12 12v4H11z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 22,
  r: 11
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M28 38c8.837 0 16-7.163 16-16S36.837 6 28 6s-16 7.163-16 16"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 19a3 3 0 0 1 3-3h3v10H9a3 3 0 0 1-3-3zM50 23a3 3 0 0 1-3 3h-3V16h3a3 3 0 0 1 3 3z"
}))));
export default SvgContactCenter;